import { render, staticRenderFns } from "./LogoutView.vue?vue&type=template&id=839c3cee&scoped=true&"
import script from "./LogoutView.vue?vue&type=script&lang=js&"
export * from "./LogoutView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839c3cee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('839c3cee')) {
      api.createRecord('839c3cee', component.options)
    } else {
      api.reload('839c3cee', component.options)
    }
    module.hot.accept("./LogoutView.vue?vue&type=template&id=839c3cee&scoped=true&", function () {
      api.rerender('839c3cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LogoutView.vue"
export default component.exports